<template>
    <div v-if="!loading">
        <div
            v-for="(item, index) in getByKey(this.parameters.key).data"
            :key="item.id"
            class="rounded-md shadow-md hover:shadow-lg p-4 flex flex-row items-center gap-4 cursor-pointer transition-all ease-in-out group bg-white"
        >
            <VideoMatrixItem :data="item" :index="index" v-model:active="active" />
        </div>

        <div class="flex justify-end mt-4">
            <Pagination :limit="-1" :data="getByKey(this.parameters.key)" @pagination-change-page="paginate" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
    data: () => ({
        loading: false,
        active: 0
    }),

    mounted() {
        this.indexSocialMedia();
    },

    props: ['parameters'],

    methods: {
        paginate(page) {
            this.loading = true;
            this.active = 0;
            this.indexSocialMedia({
                page: page
            });
        },
        async indexSocialMedia(params) {
            this.loading = true;
            let config = {
                params: this.parameters
            };

            _.merge(config.params, params);

            return await this.$store.dispatch('social_media/index', config).then(() => {
                this.loading = false;
            });
        }
    },

    computed: {
        ...mapGetters('social_media', ['getByKey'])
    }
};
</script>
